import { Box } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { PromotedContent } from '../../../../components'
import { homeEnterpriseSlice } from '../../../../reducers'
import { ProfileLpqSection } from '../../../profile/components/lpq-section'
import { useHomeEnterpriseContext } from '../../context/home-enterprise-page-context'
import { useTrackHomeEnterpriseEvent } from '../../hooks/useTrackHomeEnterpriseEvent'
import { AccelerateBanner } from './accelerate-banner'
import { AiSkillsPracticeRails } from './ai-skills-practice-rails'
import { BrowseByCategoriesRails } from './browse-by-categories-rails'
import { CategoryRails } from './category-rails'
import { MCoachPromo } from './mcoach-promo'
import { MSBRails } from './msb-rails'
import { PromoteFeaturesRails } from './promote-features-rails'
import { QuizRails } from './quiz-rails'
import { RelatedLastReadRails } from './related-last-read-rails'
import { SkillBitesRails } from './skill-bites-rails'
import { WhatsNewRails } from './whats-new-rails'
import HumanMadeBanner from '../../../../components/human-made-banner'
import { WhatsNewHomeSection } from '../../../../components/whats-new/whats-new-home-section'
import { HomeRails } from '../home-rails'
export const HOME_SECTION_TYPE = {
  PROMOTED_CONTENT: 'promotedContent',
  CATEGORY: 'category',
  M_COACH: 'mCoach',
  ACCELERATE: 'accelerate',
  MSB: 'msb',
  PROMOTE_FEATURE: 'promoteFeature',
  SKILL_BITE: 'skillBite',
  WHATS_NEW: 'whatsNew',
  QUIZ: 'quiz',
  ONBOARDING: 'onboarding',
  BROWSE_BY_CATEGORIES: 'browseByCategories',
  RELATED_LAST_READ: 'relatedLastRead',
  AI_SKILLS_PRACTICE: 'aiSkillsPractice'
}

export const HomeSections = () => {
  const homePageSections = useSelector(homeEnterpriseSlice.selectors.selectHomePageSections)
  const homePageSectionsLoading = useSelector(homeEnterpriseSlice.selectors.selectHomePageSectionsLoading)
  const { showAddToPlaylist } = useHomeEnterpriseContext()
  const { trackArticleClickEvent } = useTrackHomeEnterpriseEvent()

  const renderSection = (section, index) => {
    if (section.type === HOME_SECTION_TYPE.PROMOTED_CONTENT) {
      return (
        <PromotedContent
          key={index}
          onCardSelect={(content, position) => {
            trackArticleClickEvent(section.type, content.locationId, {
              title: content.title,
              itemIndex: position
            })
          }}
          onAddToPlaylist={showAddToPlaylist}
          promotedContent={section.data}
          isLoading={homePageSectionsLoading}
        />
      )
    }

    if (section.type === HOME_SECTION_TYPE.M_COACH) {
      return (
        <Box key={index}>
          <MCoachPromo />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.ACCELERATE) {
      return (
        <Box key={index}>
          <AccelerateBanner />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.MSB) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <MSBRails msbSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.CATEGORY) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <CategoryRails categorySection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.RELATED_LAST_READ) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <RelatedLastReadRails relatedLastReadSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.ONBOARDING) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <ProfileLpqSection />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.PROMOTE_FEATURE) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <PromoteFeaturesRails promoteFeaturesSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.SKILL_BITE) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <SkillBitesRails skillBitesSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.WHATS_NEW) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <WhatsNewRails whatsNewSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.QUIZ) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <QuizRails quizSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.BROWSE_BY_CATEGORIES) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <BrowseByCategoriesRails browseByCategoriesSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.AI_SKILLS_PRACTICE) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <AiSkillsPracticeRails aiSkillsPracticeSection={section.data} />
        </Box>
      )
    }

    return null
  }

  return (
    <Box
      data-test='home-page-sections-container'
      sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}
    >
      {/* Product updates from the last two weeks; renders nothing when there are none (PENG-3809). */}
      <WhatsNewHomeSection Rails={HomeRails} />
      {homePageSections.map((section, index) => {
        return renderSection(section, index)
      })}
      {/* No top spacing — the parent column already spaces children via gap:4. */}
      <HumanMadeBanner dataTest='home-human-made-banner' bottomDivider={false} disableTopSpacing />
    </Box>
  )
}
